import type { NdtProcedure } from "../../../domain/ndt/ndt-procedure.js";
import type { NdtProcedureRepository } from "../../../repositories/operational-repositories.js";

const STORAGE_KEY = "ndt_procedures";

export class InMemoryNdtProcedureRepository implements NdtProcedureRepository {
  private procedures = new Map<string, NdtProcedure>();

  constructor() {
    this.loadFromStorage();
  }

  private loadFromStorage() {
    try {
      if (typeof localStorage !== "undefined") {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
          const parsed: NdtProcedure[] = JSON.parse(stored);
          for (const p of parsed) {
            this.procedures.set(p.id, p);
          }
        }
      }
    } catch (e) {
      console.warn("Failed to load NDT procedures from storage:", e);
    }
  }

  private persistStorage() {
    try {
      if (typeof localStorage !== "undefined") {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(this.procedures.values())));
      }
    } catch (e) {
      console.warn("Failed to persist NDT procedures to storage:", e);
    }
  }

  async findById(id: string): Promise<NdtProcedure | null> {
    this.loadFromStorage();
    return this.procedures.get(id) || null;
  }

  async listAll(): Promise<readonly NdtProcedure[]> {
    this.loadFromStorage();
    return Array.from(this.procedures.values());
  }

  async save(procedure: NdtProcedure): Promise<void> {
    this.procedures.set(procedure.id, { ...procedure });
    this.persistStorage();
  }

  async delete(id: string): Promise<void> {
    this.procedures.delete(id);
    this.persistStorage();
  }
}
